import { ClientBase } from '../ClientBase'

export default class SignatureInfo extends ClientBase {
  signatureDate = ''

  constructor (type: 'client_0'| 'client_1' = 'client_0') {
    super(type)
  }
}
